/*
 * @Author: Next.js Image Loader
 * @Date: 2025-09-23
 * @Description: 自定义图片 loader，直接返回 S3 URL，绕过 Next.js 图片优化服务
 */

import { type ImageLoader } from 'next/image';

/**
 * 自定义图片 loader，直接返回原始 S3 URL
 * 这样可以绕过 Next.js 的 /_next/image 优化服务，直接访问 S3
 */
const imageLoader: ImageLoader = ({ src, quality, width }) => {
  // 直接返回原始 src，因为它已经经过 useImageSrc 处理为完整的 S3 URL
  // 不添加 Next.js 的优化参数，让浏览器直接访问 S3
  // ivm用的话是im=Resize,width=800这种语法
  // 黑五之后再开启resize
  return `${src}?im=Resize,width=${width},type=downsize&q=${quality || 75}`;
};

export default imageLoader;
